<template>
  <div id="app">
    <router-view v-if="isRouterAlive" :key="key" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  created() {
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
    };
  },
  computed: {
    key() {
      return this.$route.name
        ? this.$route.name + new Date()
        : this.$route + new Date();
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    }
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
  font-size: 14px;
}

img {
  max-width: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
.iconfont {
  margin-right: 7px;
}

@import "./common/font/font.css";
@media (min-width: 1024px) {
  html {
    font-size: 18px;
  }
}

/*>=1024的设备*/

@media (min-width: 1100px) {
  html {
    font-size: 20px;
  }
}

/*>=1100的设备*/

@media (min-width: 1280px) {
  html {
    font-size: 22px;
  }
}

/*>=1280的设备*/

@media (min-width: 1366px) {
  html {
    font-size: 24px;
  }
}

@media (min-width: 1440px) {
  html {
    font-size: 25px;
  }
}

@media (min-width: 1680px) {
  html {
    font-size: 28px;
  }
}

@media (min-width: 1920px) {
  html {
    font-size: 34px;
  }
}
</style>
<style lang="scss">
@import "@/assets/css/normalize.scss";
.el-tooltip__popper {
  &.is-dark {
    background: rgba(255, 255, 255, 0.1);
    box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.04);
    backdrop-filter: blur(10px);
    font-size: 14px;
    font-weight: 400;
    color: #b9c3c3;
    line-height: 1;
    padding: 16px;
  }

  .popper__arrow {
    border-top-color: rgba(255, 255, 255, 0.1) !important;
    &::after {
      border-top-color: rgba(255, 255, 255, 0.1) !important;
    }
  }
}

.el-message-box {
  background-color: #10082e;
  background-image: linear-gradient(
    124deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.01) 100%
  );
  border-radius: 8px;
  border: none;
  backdrop-filter: blur(20px);
  box-shadow: 0 0 6px 2px rgba(255, 255, 255, 0.01);

  .el-message-box__header {
    padding: 20px 16px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .el-message-box__title {
    color: #fff;
    font-size: 16px;
  }

  .el-message-box__headerbtn {
    position: static;
    width: 16px;
    height: 16px;
    background-image: url("~@/assets/images/icon_close_24.svg");
    background-repeat: no-repeat;
    background-size: cover;
    background-repeat: no-repeat;

    .el-message-box__close {
      display: none;
    }
  }

  .el-message-box__content {
    padding: 8px 16px 16px;
  }

  .el-message-box__status {
    width: 16px;
    height: 16px;
    padding: 0px;
    background-image: url("~@/assets/images/icon_error.svg");
    background-repeat: no-repeat;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;
    transform: none;

    &::before {
      display: none;
    }
  }

  .el-message-box__message {
    flex: 1;
    font-size: 14px;
    font-weight: 400;
    color: #ffffff;
    line-height: 1;
    padding-left: 10px;

    p {
      line-height: 1.2;
    }
  }

  .el-message-box__btns {
    .el-button {
      width: 98px;
      height: 36px;
      border: none;
      border-radius: 0;
      background-color: transparent;
      background-image: url("~@/assets/images/button_normal.svg");
      background-repeat: no-repeat;
      background-size: cover;
      background-repeat: no-repeat;
      font-size: 14px;
      font-weight: 400;
      color: #00f68c;
      padding: 0;
      padding-bottom: 4px;
    }

    .el-button:last-child {
      background-image: url("~@/assets/images/login_button.svg");
      color: #11082f;
    }

    & > .el-button + .el-button {
      margin-left: 24px;
    }
  }
}

.el-notification {
  width: 400px;
  background-color: #10082e;
  background-image: linear-gradient(
    124deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.01) 100%
  );
  border-radius: 8px;
  border: none;
  backdrop-filter: blur(20px);
  box-shadow: 0 0 6px 2px rgba(255, 255, 255, 0.1);
}

.el-notification__icon {
  width: 16px;
  height: 16px;
  background-image: url("~@/assets/images/icon_error.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-repeat: no-repeat;
  padding: 1px;

  &::before {
    display: none;
  }
}

.el-notification__group {
  margin-left: 8px;
}

.el-notification__title {
  color: rgba(255, 255, 255, 0.8);
}

.el-notification__content {
  color: #fff;
}

.el-message-box__container {
  display: flex;
  align-items: flex-start;
}

.el-notification__closeBtn {
  width: 16px;
  height: 16px;
  background-image: url("~@/assets/images/icon_close_24.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-repeat: no-repeat;
  top: 14px;

  &::before {
    display: none;
  }
}

.el-popover {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  border-radius: 10px;
  line-height: 1;
  padding: 8px;
  min-width: auto;
  & > img {
    border-radius: 10px;
  }

  .popper__arrow {
    border-right-color: rgba(255, 255, 255, 0.1) !important;
    border-left-color: rgba(255, 255, 255, 0.1) !important;
    &::after,
    &::before {
      border-right-color: rgba(255, 255, 255, 0) !important;
      border-left-color: rgba(255, 255, 255, 0) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue